import React from "react";
import "./Footer.scss";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa6";

const basePath = "https://cdlschool.com";
const socialMediaLinks = [
  { url: "https://www.facebook.com/TheCDLSchool/#", icon: <FaFacebookF /> },
  { url: "https://www.linkedin.com/company/the-cdl-school/#", icon: <FaLinkedinIn /> },
  { url: "https://x.com/thecdlschool", icon: <FaTwitter /> },
  { url: "https://www.instagram.com/thecdlschool/#", icon: <FaInstagram /> },
];

const Footer = () => {
  return (
    <footer className="footer--site-page">
    <div className="footer_container">
      <div className="footer_content">
        <div className="footer_column">
          <h4>About</h4>
          <a href={`${basePath}/about`}>Why The CDL School?</a>
          <a href={`${basePath}/about/locations`}>Locations</a>
          <a href={`${basePath}/about/employer-solutions`}>Solutions for Employers</a>
        </div>
        <div className="footer_column">
          <h4>CDL Training Programs</h4>
          <a href={`${basePath}/troops-into-transportation`}>Troops Into Transportation</a>
          <a href={`${basePath}/cdl-training/eldt-training`}>ELDT Training</a>
          <a href={`${basePath}/cdl-training/cdl-class-a-training`}>CDL Class A</a>
          <a href={`${basePath}/cdl-training/cdl-class-b-training`}>CDL Class B</a>
        </div>
        <div className="footer_column">
          <h4>Privacy and Data</h4>
          <a href={`${basePath}/privacy-policy`}>Privacy Policy</a>
          <a href={`${basePath}/terms-and-conditions`}>Terms and Conditions</a>
          <a href={`${basePath}/accessibility`}>Accessibility</a>
        </div>
      </div>
      <div className="footer_media">
        {socialMediaLinks.map((link) => (
          <a href={link.url} target="_blank" rel="noopener noreferrer" key={link.url}>
            {link.icon}
          </a>
        ))}
      </div>
    </div>
    </footer>
  );
};

export default Footer;
